import { render, staticRenderFns } from "./TruckLinksMeasurementFragment.vue?vue&type=template&id=5ef2f13b&"
import script from "./TruckLinksMeasurementFragment.vue?vue&type=script&lang=js&"
export * from "./TruckLinksMeasurementFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports